/*
 *  Convert internal AEM path to site URL.
 *
 *  Paths must be valid AEM paths, otherwise will be redirected to homepage.
 */
import env from 'env/env';

export default path => {
  const slug = path.includes('/content/waitrosegroceriescms/en/')
    ? path.split('/content/waitrosegroceriescms/en/')[1]
    : '';

  return slug ? `${env.root}/${slug}` : env.root;
};
